import {
  ICompany,
  IImplantLibrary,
  ImplantLibraryData,
  ITooth,
  IToothCopyData,
  TDentalArch,
} from 'lib/types/clinic/projectTypes';
import { createStoreWithSetters } from './utils';

interface IStoreProps {
  numbering: number; // FDI, URS 여부
  teeth: ITooth[]; // 치아 모음
  tooth: ITooth | null; // 단일 치아
  bridge: number[]; // 브릿지
  copyData: IToothCopyData; // 복제 데이터
  indicationTab: number; // 인디케이션 탭 (유형, 재료, 쉐이드)
  optionTab: number; // 옵션 탭 (기본, 고급)
  indicationAlias: string;
  materialAlias: string;
  isTypeMore: boolean;
  isHasData: boolean;
  implantLibrary: IImplantLibrary | null;
  implantLibraryData: ICompany[] | null;
  pimNormalSet: Set<TDentalArch>;
}

export const useCreateProjectIndicationStore = createStoreWithSetters<IStoreProps>(
  {
    numbering: 0,
    teeth: [],
    tooth: null,
    bridge: [],
    copyData: {},
    indicationTab: 0,
    optionTab: 0,
    indicationAlias: '',
    materialAlias: '',
    isTypeMore: false,
    isHasData: false,
    implantLibrary: null,
    implantLibraryData: null,
    pimNormalSet: new Set(['upper', 'lower']),
  },
  'project_create_indication',
);
